import React from "react";
import BlogContent from "../../Views/BlogContent";
import SEOHead from "../SEO/SEOHead";

import "./BlogHome.css";

const BlogHome = () => {
  return (
    <div className="NewBlogHome">
      <SEOHead
        title="Anime Blog - Reviews & Articles | ChibiDash"
        description="Anime reviews and articles on ChibiDash Blog. Read about Yahari, Haikyu, Your Lie in April, Giant Killing, Spy x Family and more."
        path="/new-blog-home"
      />
      <h1>Anime Blog - Reviews & Articles</h1>

      <BlogContent />
    </div>
  );
};

export default BlogHome;
